
import React, { useCallback, useState, useEffect, useRef } from 'react';
import { Bubble } from 'tea-component';
import './index.scss';

const ELLIPSIS_CHECK_DELAY = 100;

export default function EllipsisHover(props: any) {
  const { text, className, placement = "top", placementOffset, textBubble = '' } = props;
  const myClassName = className ? className : 'ellipsis-hover';

  const divRef = useRef<HTMLDivElement | null>(null);
  const textRef = useRef<HTMLSpanElement | null>(null);
  const [isEllipsis, setIsEllipsis] = useState(false);
  const [resizeTick, setResizeTick] = useState(0);
  const [size, setSize] = useState({
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
  })

  const onResize = useCallback(() => {
    try {
      setSize({
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight,
      })
    } catch (_err) { }
  }, [])

  useEffect(() => {
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  // 监听元素自身尺寸变化：容器宽度变化、屏幕缩放后布局重排等场景下重新触发溢出判定，仅补充测量时机
  useEffect(() => {
    const currentElement = divRef?.current;
    if (!currentElement || typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    const resizeObserver = new ResizeObserver(() => {
      setResizeTick((tick) => tick + 1);
    });
    resizeObserver.observe(currentElement);

    return () => {
      resizeObserver.disconnect();
    };
  }, [])

  useEffect(() => {
    const timer = window.setTimeout(() => {
      // 用文本节点自身宽度与容器可用宽度比较，避免 isEllipsis 切换为嵌套结构后容器 scrollWidth 误判为不溢出
      const container = divRef?.current;
      const textEl = textRef?.current;
      const hasHorizontalOverflow = (textEl?.offsetWidth || 0) > (container?.clientWidth || 0);
      const hasVerticalOverflow = (textEl?.offsetHeight || 0) > (container?.clientHeight || 0);

      setIsEllipsis(hasHorizontalOverflow || hasVerticalOverflow);
    }, ELLIPSIS_CHECK_DELAY);

    return () => {
      window.clearTimeout(timer);
    };
  }, [size, text, resizeTick]);

  return (
    <div className={myClassName} ref={divRef}>
      {
        (isEllipsis || textBubble !== '') ?
          <Bubble
            overlayClassName={`${myClassName}-bubble`}
            arrowPointAtCenter
            placement={placement}
            placementOffset={placementOffset}
            dark
            content={textBubble !== '' ? textBubble : text}
          >
            {/* feat:添加div外层，修复hover对齐方式 */}
            <div className={myClassName}>
              <span ref={textRef} style={{ cursor: 'pointer' }} className={`${myClassName}-text`}>{text}</span>
            </div>
          </Bubble>
          : <span ref={textRef} className={`${myClassName}-text`}>{text}</span>
      }
    </div>
  )
}
